import * as React from 'react';
import { Responsive } from 'vendors/semantic-ui';

import { DescriptionLoader, ImagesListBlocLoader } from 'modules/shared-cms-advanced';
import { LightSeparator } from 'modules/shared-ui/components';
import { NouveautesCatalogueLoader } from 'modules/shared-cms-catalogue/enhanced-blocs/nouveautes-catalogue/nouveautes-catalogue-component-loader';
import { CarrouselLoader } from 'modules/shared-cms-advanced/enhanced-blocs/carrousel/carrousel-component-loader';
import { ActualiteLoader } from 'modules/shared-cms-advanced/enhanced-blocs/actualite/actualite-component-loader';
import { TendanceCatalogueLoader } from 'modules/shared-cms-catalogue/enhanced-blocs/tendance-catalogue/tendance-catalogue-component-loader';
import { configUI } from 'config';

import styles from './home-alt-page.module.css';

export const HomeAltLoader: React.FC = React.memo(() => {
    return (
        <div className={styles.rootContainer}>
            <CarrouselLoader placeholderSize="large" compactResponsive largeLegend />
            <Responsive as={React.Fragment} maxWidth={configUI.responsive.mobile.maxWidth}>
                <div className={styles.separator}>
                    <LightSeparator />
                </div>
            </Responsive>
            <NouveautesCatalogueLoader />
            <div className={styles.separator}>
                <LightSeparator />
            </div>
            <div className={styles.universeBlock} style={{ width: '100%' }}>
                <DescriptionLoader fullwidth />
            </div>
            <ImagesListBlocLoader />
            <ImagesListBlocLoader />
            <ActualiteLoader />
            <TendanceCatalogueLoader />
        </div>
    );
});
